module.exports = ["fan",
    "press",
    "cNC",
    "compressor",
    "pump",
    "Coupling",
    "generator",
    "conveyor",
    "rolling",
    "saw",
    "mixingDrum",
    "Blister(Packing)",
    "postBinBlender",
    "camBlister"];